<template>
  <div v-if="current">
    
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field
                label="Descrição"
                v-model="current.description"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Status"
                v-model="current.enabled"
                :items="status"
                outlined
                dense
                disabled
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Host"
                v-model="current.host"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Porta"
                v-model="current.port"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Usuário"
                v-model="current.username"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Senha"
                v-model="current.password"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Tech Prefix"
                v-model="current.techPrefix"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Tipo"
                v-model="current.type"
                :items="types"
                outlined
                dense
                disabled
              ></v-select>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Discagem"
                v-model="current.dialplan"
                :items="dialplans"
                outlined
                dense
                disabled
              ></v-select>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Observação"
                v-model="current.obs"
                outlined
                dense
                disabled
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="dialogEnable()" v-if="current.enabled == false">Habilitar</v-btn>
        <v-btn color="error" @click="dialogDisable()" v-if="current.enabled == true">Desabilitar</v-btn>
        <v-btn color="primary" @click="dialogIdent()">Alterar Identificação</v-btn>
        <v-btn color="primary" @click="dialogAuth()">Alterar Autenticação</v-btn>
        <v-btn color="primary" @click="dialogDial()">Alterar Discagem</v-btn>
        <v-btn color="primary" @click="dialogObs()">Alterar Observação</v-btn>
        <v-btn color="warning" @click="routes()">Rotas</v-btn> 
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_enable" max-width="500px">
      <v-card>
        <v-card-title>Habilitar</v-card-title>
        <v-card-text>
          Tem certeza que deseja habilitar o tronco?
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putEnable()">Habilitar</v-btn>
          <v-btn color="default" @click="dialog_enable = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_disable" max-width="500px">
      <v-card>
        <v-card-title>Desabilitar</v-card-title>
        <v-card-text>
          Tem certeza que deseja desabilitar o tronco?
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="putDisable()">Desabilitar</v-btn>
          <v-btn color="default" @click="dialog_disable = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="500px">
      <v-card>
        <v-card-title>Alterar observação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Observação"
              v-model="changed.obs"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ident" max-width="500px">
      <v-card>
        <v-card-title>Alterar Identificação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Nome"
              v-model="changed.name"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Descrição"
              v-model="changed.description"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putIdent()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_ident = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_auth" max-width="500px">
      <v-card>
        <v-card-title>Alterar Autenticação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Host"
              v-model="changed.host"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Porta"
              v-model="changed.port"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Usuário"
              v-model="changed.username"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Senha"
              v-model="changed.password"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAuth()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_auth = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_dial" max-width="500px">
      <v-card>
        <v-card-title>Alterar Discagem</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Tech Prefix"
              v-model="changed.techPrefix"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Discagem"
                v-model="changed.dialplan"
                :items="dialplans"
                outlined
                dense
              ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putDial()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_dial = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    status: [
      { value: true, text: "Habilitado" },
      { value: false, text: "Desabilitado" }
    ],
    types: [
      { value: "sip", text: "SIP" },
      { value: "local", text: "Local" },
      { value: "voip", text: "Voip" },
      { value: "did", text: "DID" }
    ],
    dialplans: [
      { value: 1, text: "E164" },
      { value: 2, text: "00 + E164" },
      { value: 3, text: "0 + ddd + numero e 00 + ddi + numero" },
      { value: 4, text: "Tech Prefix + E164" },
      { value: 5, text: "Tech Prefix + [portabilidade] + E164" }
    ],
    portabilidade: [
      { value: true, text: "Habilitado" },
      { value: false, text: "Desabilitado" }
    ],
    changed: {},
    dialog_loading: false,
    dialog_enable: false,
    dialog_disable: false,
    dialog_ident: false,
    dialog_auth: false,
    dialog_obs: false,
    dialog_dial: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/trunk/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    dialogEnable: function(){
      this.changed.enabled = true;
      this.dialog_enable = true;
    },
    putEnable: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/enable/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_enable = false;
          alert("Habilitado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao habilitar!");
          console.log(error);
        });
    },
    dialogDisable: function(){
      this.changed.enabled = false;
      this.dialog_disable = true;
    },
    putDisable: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/disable/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_disable = false;
          alert("Desabilitado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao desabilitar!");
          console.log(error);
        });
    },
    dialogIdent: function(){
      this.changed.name = this.current.name;
      this.changed.description = this.current.description;
      this.dialog_ident = true;
    },
    putIdent: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/ident/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_ident = false;
          alert("Identificação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar identificação!");
          console.log(error);
        });
    },
    dialogAuth: function(){
      this.changed.host = this.current.host;
      this.changed.port = this.current.port;
      this.changed.username = this.current.username;
      this.changed.password = this.current.password;
      this.dialog_auth = true;
    },
    putAuth: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/auth/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_auth = false;
          alert("Autenticação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar autenticação!");
          console.log(error);
        });
    },
    dialogDial: function(){
      this.changed.techPrefix = this.current.techPrefix;
      this.changed.dialplan = this.current.dialplan;
      this.dialog_dial = true;
    },
    putDial: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/dial/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_dial = false;
          alert("Discagem alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar discagem!");
          console.log(error);
        });
    },
    dialogObs: function(){
      this.changed.obs = this.current.obs;
      this.dialog_obs = true;
    },
    putObs: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/trunk/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observação!");
          console.log(error);
        });
    },
    routes: function(){
      router.push({path: "/trunk/"+this.$route.params.id+"/routes"});
    }
  }
};
</script>